import type { ReportDefinition } from "@/modules/reports/report-calculations";

export type ReportCategory =
  | "Population"
  | "Household"
  | "Education"
  | "Income and Work"
  | "Children and Immunization"
  | "Women and Family Planning"
  | "Health and Disability"
  | "Mortality"
  | "Civic and Social"
  | "Migration";

export type ReportCategoryDefinition = {
  label: ReportCategory;
  reportIds: number[];
};

export const REPORT_CATEGORIES: ReportCategoryDefinition[] = [
  { label: "Population", reportIds: [1, 3, 4, 5, 6] },
  { label: "Household", reportIds: [2, 36, 41, 42] },
  { label: "Education", reportIds: [7, 8, 9] },
  { label: "Income and Work", reportIds: [10, 11, 12, 35] },
  { label: "Children and Immunization", reportIds: [13, 14, 15] },
  { label: "Women and Family Planning", reportIds: [16, 17, 18, 19, 20, 21, 22] },
  { label: "Health and Disability", reportIds: [23, 24, 25, 26] },
  { label: "Mortality", reportIds: [27, 28, 29, 30, 31] },
  { label: "Civic and Social", reportIds: [32, 33, 34] },
  { label: "Migration", reportIds: [37, 38, 39, 40] },
];

const reportCategoryMap = new Map<number, ReportCategory>(
  REPORT_CATEGORIES.flatMap((category) => category.reportIds.map((reportId) => [reportId, category.label] as const)),
);

export function getReportCategory(reportId: number): ReportCategory {
  return reportCategoryMap.get(reportId) ?? "Population";
}

export function getReportSearchText(definition: ReportDefinition) {
  return `table ${definition.id} ${definition.title} ${getReportCategory(definition.id)}`.toLowerCase();
}
